import { render } from "./CategoryTable.vue?vue&type=template&id=7701a20e&scoped=true"
import script from "./CategoryTable.vue?vue&type=script&lang=js"
export * from "./CategoryTable.vue?vue&type=script&lang=js"

import "./CategoryTable.vue?vue&type=style&index=0&id=7701a20e&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7701a20e"]])

export default __exports__